import Checkbox from '@material-ui/core/Checkbox'
import Divider from '@material-ui/core/Divider'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import CheckBoxOutlinedIcon from '@material-ui/icons/CheckBoxOutlined'
import { map } from 'lodash'
import { connect } from 'react-redux'
import { TREE_LEVELS } from '../../../services/constants'
import { SELECT_ALL_LABEL } from './services/customTree-constants'
import locationPickerTreeActions from './services/locationPickerTree-actions'
import styles from './style'
import TreeNode from './TreeNode'

const TreeList = withStyles(styles)((props) => {
  const {
    nodes,
    setExpandNode,
    setCheckNode,
    classes,
    changeSelectAll,
    mainLevel,
    isAllSelected,
    setSelectAllState,
    setPropertyExpandNode,
    setPropertyCheckNode,
  } = props

  const onCheck = (key, deep, value, propertyId) => {
    if (deep === TREE_LEVELS.PROPERTY) {
      setPropertyCheckNode(key, value, mainLevel)
    } else {
      setCheckNode(key, value, mainLevel, propertyId)
    }

    setSelectAllState()
  }

  const onExpand = (key, deep, propertyId) => {
    if (deep === TREE_LEVELS.PROPERTY) {
      setPropertyExpandNode(key)
    } else {
      setExpandNode(key, propertyId)
    }
  }

  const onSelectAll = () => {
    changeSelectAll(!isAllSelected)
  }

  const renderTreeNodes = (nodes, parent = {}, deep) => {
    const renderNodes = (nodes, deep) => {
      return map(nodes, (node) => {
        const parentExpanded = parent.key ? parent.expanded : true

        if (!parentExpanded) {
          return null
        }

        const margin = deep * 15 + 'px'
        const nextDeep = deep + 1

        return (
          <div key={node.id}>
            <TreeNode
              margin={margin}
              value={node.id}
              propertyId={node.propertyId}
              onExpand={onExpand}
              onCheck={onCheck}
              checked={node.checked}
              indeterminate={node.indeterminate || false}
              name={node.name}
              expanded={node.expanded}
              isParent={node.isParent}
              deep={node.locationType}
            >
              {node.isParent && renderTreeNodes(node.children, node, nextDeep)}
            </TreeNode>
          </div>
        )
      })
    }

    return renderNodes(nodes, deep)
  }

  const renderSelectAll = () => {
    return (
      <div className={classes.labelContainer}>
        <Checkbox
          className={classes.treeCheckbox}
          checkedIcon={<CheckBoxOutlinedIcon />}
          checked={isAllSelected}
          color={isAllSelected ? 'primary' : 'default'}
          onChange={onSelectAll}
        />
        <Typography
          className={classes.selectAllLabel}
          color={isAllSelected ? 'primary' : 'textPrimary'}
          variant="subtitle2"
        >
          {SELECT_ALL_LABEL}
        </Typography>
      </div>
    )
  }

  return (
    <>
      {renderSelectAll()}
      <Divider className={classes.divider} />
      <div className={classes.nodesWrapper}>
        {renderTreeNodes(nodes, undefined, 0)}
      </div>
    </>
  )
})

const mapStateToProps = (state) => ({
  nodes: state.locationPickerTreeReducer.nodes,
  isAllSelected: state.locationPickerTreeReducer.isAllSelected,
})

const mapDispatchToProps = (dispatch) => {
  return {
    setExpandNode: (key, propertyId) =>
      dispatch(locationPickerTreeActions.setExpandNode(key, propertyId)),
    setPropertyExpandNode: (key) =>
      dispatch(locationPickerTreeActions.setPropertyExpandNode(key)),
    setPropertyCheckNode: (key, bool, mainLevel) =>
      dispatch(
        locationPickerTreeActions.setPropertyCheckNode(key, bool, mainLevel)
      ),
    setCheckNode: (key, bool, mainLevel, propertyId) =>
      dispatch(
        locationPickerTreeActions.setCheckNode(key, bool, mainLevel, propertyId)
      ),
    changeSelectAll: (isSelectAll) =>
      dispatch(locationPickerTreeActions.selectAll(isSelectAll)),
    setSelectAllState: () =>
      dispatch(locationPickerTreeActions.setSelectAllState()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TreeList)
